import React, { CSSProperties } from "react";
import { ImageData } from "./interface/ImageData";
import Image, { IImageProps } from "./Image";
import clsx from "clsx";
import { _ImageResponsiveRoot } from "./Image.styled";
import { responsiveMap } from "../Grid/_utils/responsiveObserve";

// main component
export type ResponsivePartialProps = Omit<Partial<IImageProps>, "image"> & {
  image: ImageData;
};
export interface IImageResponsiveProps extends Omit<IImageProps, "image"> {
  desktop: ResponsivePartialProps;
  mobile: ResponsivePartialProps;
  style?: CSSProperties;
  href?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  log?: boolean;
  rootClassName?: string;
}
const ImageResponsive = (props: IImageResponsiveProps) => {
  const {
    desktop,
    mobile,
    className,
    style,
    onClick,
    log,
    rootClassName,
    ...rest
  } = props;

  const mobileOk =
    !!mobile.image &&
    mobile.image.id !== "" &&
    mobile.image.id !== "-1";
  const desktopOk =
    !!desktop.image &&
    desktop.image.id !== "" &&
    desktop.image.id !== "-1";

  let mainImage: ResponsivePartialProps;
  const additionalImage: IImageProps["additionalImage"] = [];

  if (mobileOk && desktopOk) {
    mainImage = {
      ...mobile,
      image: { ...mobile.image, media: responsiveMap.mobile },
    };
    additionalImage.push({
      ...desktop,
      image: { ...desktop.image, media: responsiveMap.lg },
    });
  } else if (mobileOk) {
    mainImage = mobile;
  } else if (desktopOk) {
    mainImage = desktop;
  } else {
    mainImage = mobile;
  }

  return (
    <_ImageResponsiveRoot
      style={style}
      className={clsx("ro-image-responsive", rootClassName)}
      onClick={onClick}
    >
      <Image
        {...rest}
        {...mainImage}
        additionalImage={additionalImage}
        log={log}
        className={clsx(className)}
      />
      {/* {loaded &&
        !isMobile &&
        desktop.image &&
        desktop.image.id !== "" &&
        desktop.image.id !== "-1" && (
          <Image
            className={clsx(className, "ro-image-responsive__desktop")}
            {...rest}
            {...desktop}
          />
        )}
      {mobile.image && mobile.image.id !== "" && mobile.image.id !== "-1" && (
        <Image
          className={clsx(className, "ro-image-responsive__mobile")}
          {...rest}
          {...mobile}
        />
      )} */}
    </_ImageResponsiveRoot>
  );
};

export default ImageResponsive;
